import { useState } from "react";
import "../Main.css";
import "../css/fontawesome-5.14.0.min.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { Flag } from "semantic-ui-react";

// type LanguageOption = {
//   value: string;
//   label: JSX.Element;
// };

const Menu = () => {
  const [isHover, setIsHover] = useState({
    home: false,
    services: false,
    project: false,
    pages: false,
    shop: false,
    blog: false,
    multiplepage: false,
    onepage: false,
    team: false,
    solutions: false,
  });
  const handleMouseEnter = (item: any) => {
    setIsHover((prevState) => ({
      ...prevState,
      [item]: true,
    }));
  };

  const handleMouseLeave = (item: any) => {
    setIsHover((prevState) => ({
      ...prevState,
      [item]: false,
    }));
  };

  // const { i18n } = useTranslation();
  const { t } = useTranslation();

  // const languages: LanguageOption[] = [
  //   {
  //     value: "en",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#000" }}>
  //         <Flag name="vg" /> En
  //       </div>
  //     ),
  //   },
  //   {
  //     value: "az",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#000" }}>
  //         <Flag name="az" /> Az
  //       </div>
  //     ),
  //   },
  //   {
  //     value: "ar",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
  //         <Flag name="ae" /> Ae
  //       </div>
  //     ),
  //   },
  //   {
  //     value: "ru",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
  //         <Flag name="ru" /> Ru
  //       </div>
  //     ),
  //   },
  // ];

  // const [_activeLang, setActiveLang] = useState<string>("en");

  // const handleLangChange = (selectedOption: any) => {
  //   setActiveLang(selectedOption.value);
  //   i18n.changeLanguage(selectedOption.value);
  // };
  return (
    <>
      <ul className="navigation clearfix">
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("home")}
          onMouseLeave={() => handleMouseLeave("home")}
        >
          <Link to="/">{t("navHome")}</Link>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("services")}
          onMouseLeave={() => handleMouseLeave("services")}
        >
          <Link to="#">{t("navServices")}</Link>
          <ul style={{ display: `${isHover.services ? "block" : "none"}` }}>
            <li>
              <Link to="/web-development">{t("navServicesSub1")}</Link>
            </li>
            <li>
              <Link to="/mobile-app-development">{t("navServicesSub2")}</Link>
            </li>
            <li>
              <Link to="/software-development">{t("navServicesSub3")}</Link>
            </li>
            <li>
              <Link to="/dev-ops">{t("navServicesSub4")}</Link>
            </li>
            <li>
              <Link to="/cloud-computing">{t("navServicesSub5")}</Link>
            </li>
            <li>
              <Link to="/digital-marketing">{t("navServicesSub6")}</Link>
            </li>
          </ul>
          <div className="dropdown-btn">
            <span className="fas fa-chevron-down" />
          </div>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("solutions")}
          onMouseLeave={() => handleMouseLeave("solutions")}
        >
          <Link to="#">Solutions</Link>

          <ul style={{ display: isHover.solutions ? "block" : "none" }}>
<li className="solution-wrapper" style={{ padding: "20px 25px", display: "flex", gap: "40px", minWidth: "600px" }}>

  {/* Left column: Projects */}
  <div style={{ minWidth: "100px", borderRight: "1px solid #eee", paddingRight: "10px" }}>
    {/* <h6 style={{ fontSize: "13px", fontWeight: "700", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Quick Links</h6> */}
    <Link to="/projects" style={{ display: "block", padding: "6px 0", color: "#333", fontSize: "15px" }}>Projects</Link>
  </div>

  {/* Right column: Solution groups */}
  <div style={{ display: "flex", gap: "30px" }}>
    <div>
      <h6 style={{ fontSize: "13px", fontWeight: "700", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Cloud Modernization</h6>
      <Link to="/cloud-adoption" style={{ display: "block", padding: "5px 0", color: "#333", fontSize: "14px" }}>Cloud Adoption</Link>
      <Link to="/process-integration" style={{ display: "block", padding: "5px 0", color: "#333", fontSize: "14px" }}>Process Integration</Link>
    </div>

    <div>
      <h6 style={{ fontSize: "13px", fontWeight: "700", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Manufacturing</h6>
      <Link to="/manufacturing-execution" style={{ display: "block", padding: "5px 0", color: "#333", fontSize: "14px" }}>Manufacturing Execution</Link>
      <Link to="/industrial-iot" style={{ display: "block", padding: "5px 0", color: "#333", fontSize: "14px" }}>Industrial IoT</Link>
    </div>

    <div>
      <h6 style={{ fontSize: "13px", fontWeight: "700", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Business Transformation</h6>
      <Link to="/systems-of-engagement" style={{ display: "block", padding: "5px 0", color: "#333", fontSize: "14px" }}>Systems of Engagement</Link>
      <Link to="/customer-experience" style={{ display: "block", padding: "5px 0", color: "#333", fontSize: "14px" }}>Customer Experience</Link>
    </div>
  </div>

</li>
          </ul>
          <div className="dropdown-btn">
            <span className="fas fa-chevron-down" />
          </div>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("pages")}
          onMouseLeave={() => handleMouseLeave("pages")}
        >
          <Link to="/about-us">{t("navAbout")}</Link>
        </li>
        <li>
          <Link to="/press-release">{t("navPress")}</Link>
        </li>

        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("blog")}
          onMouseLeave={() => handleMouseLeave("blog")}
        >
          <Link to="#">
            Blogs
          </Link>

          <ul style={{ display: isHover.blog ? "block" : "none" }}>
            <li>
              <Link to="/blogs">Blog</Link>
            </li>
            <li>
              <Link to="/case-studies">Case Studies</Link>
            </li>
          </ul>

          <div className="dropdown-btn">
            <span className="fas fa-chevron-down" />
          </div>
        </li>

        <li>
          <Link to="/contact-us">{t("navContact")}</Link>
        </li>

        {/* <div className="d-flex justify-content-center align-items-center">
          <Select
            value={languages.find((lang) => lang.value === activeLang)}
            onChange={handleLangChange}
            options={languages}
            isSearchable={false}
          />
        </div> */}
      </ul>
    </>
  );
};

export default Menu;
